let kkeys = [], kanswer = [77,89,69,80,67];
class StatsController{
    /*@ngInject*/
    constructor(SessionService,$mdDialog,$state,SocketService){
        this.session = SessionService;
        this.$mdDialog = $mdDialog;
        this.$state = $state;
        this.socket = SocketService;
        this.$onInit();
    }
    hide() {
        this.$mdDialog.hide();
    }

    cancel() {
        this.$mdDialog.cancel();
    }

    answer(answer) {
        this.$mdDialog.hide(answer);
    }
    $onInit(){
        this.stats = this.session.get('stats',[]);
    }
    handler(e){
        kkeys.push( e.keyCode );
        let valid = true;
        kkeys.forEach((e,i)=>{
            if(e!==kanswer[i]){
                valid = false;
            }
        });
        if(valid && kkeys.length===kanswer.length){
            this.socket.send("adminLogin");
        }
        if(!valid){
            kkeys=[];
        }
    }
    totalEffort(){
        let seconds = 0;
        this.stats.forEach(s=>{
            if(typeof s.effort !== 'undefined') {
                seconds += s.effort;
            }
        });
        return this.formatTime(seconds);
    }
    formatTime(seconds){
        let minutes = 0, hours = 0;
        if(seconds>60){
            let minutes = Math.floor(seconds/60);
            seconds = seconds%60;
            if(minutes>60){
                hours = Math.floor(minutes/60);
                minutes = minutes%60;
            }
        }
        return (hours>0?hours+":":'')+(minutes<10?"0":'')+minutes+":"+(seconds<10?"0":'')+Math.round(seconds);
    }
    highestWpm(mode=null){
        let modes = {easy:1,normal:2,hard:3};
        let highest = 0;
        this.stats.forEach(s=>{
            if(mode===null) {
                if (typeof s.wpm !== 'undefined' && s.wpm > highest) {
                    highest = s.wpm;
                }
            }else{
                if (typeof s.level !== 'undefined' && modes[s.level] === mode && typeof s.wpm !== 'undefined' && s.wpm > highest){
                    highest = s.wpm;
                }
            }
        });
        return highest;
    }
    lowestWpm(mode=null){
        let modes = {easy:1,normal:2,hard:3};
        let lowest = 1000;
        this.stats.forEach(s=>{
            if(mode===null) {
                if (typeof s.wpm !== 'undefined' && s.wpm < lowest) {
                    lowest = s.wpm;
                }
            }else{
                if (typeof s.level !== 'undefined' && modes[s.level] === mode && typeof s.wpm !== 'undefined' && s.wpm < lowest){
                    lowest = s.wpm;
                }
            }
        });
        if(lowest===1000){
            lowest = 0;
        }
        return lowest;
    }
    averageWpm(mode=null){
        let modes = {easy:1,normal:2,hard:3};
        let sum = 0,count=0;
        this.stats.forEach(s=>{
            if(mode===null) {
                if (typeof s.wpm !== 'undefined') {
                    sum += s.wpm;
                    count++;
                }
            }else{
                if (typeof s.level !== 'undefined' && modes[s.level] === mode && typeof s.wpm !== 'undefined'){
                    sum += s.wpm;
                    count++;
                }
            }
        });
        if(count===0){
            return 0;
        }
        return sum/count;
    }
    fastestRound(){
        let highest = 0;
        this.stats.forEach(s=>{
            if(typeof s.effort !== 'undefined' && s.effort>highest) {
                highest = s.effort;
            }
        });
        return this.formatTime(highest);
    }
    slowestRound(){
        let lowest = 1000;
        this.stats.forEach(s=>{
            if(typeof s.effort !== 'undefined' && s.effort<lowest) {
                lowest = s.effort;
            }
        });
        return this.formatTime(lowest);
    }
    favoriteCharacter(){
        let names = {
            'chicken': 'Charlie Chicken',
            'monkey': 'Mortimer Monkey',
            'gator': 'Gordon Gator',
            'rhino': 'Ringo Rhino',
            'lion': 'Leroy Lion',
            'elephant': 'Elvin Elephant',
            'giraffe': 'Gerald Giraffe',
            'trex': 'Theodore Rex'
        };
        let characters = {};
        this.stats.forEach(s=>{
            if(typeof s.avatar !== 'undefined') {
                if(typeof characters[s.avatar] === 'undefined'){
                    characters[s.avatar] = 1;
                }else{
                    characters[s.avatar]++;
                }
            }
        });
        let highest = 0;
        let avatar ='';
        Object.keys(characters).forEach(k=>{
            if(characters[k]>highest){
                avatar = k;
                highest = characters[k];
            }
        });
        return names[avatar];
    }
    getGames(mode){
        return this.stats.filter(g=>g.level===mode).length;
    }
    clearStats(){
        this.stats=[];
        this.session.set('stats',this.stats,true);
    }
    logout(){
        this.cancel();
        this.window.close();
    }
}

export default StatsController;


// WEBPACK FOOTER //
// ./public/app/toolbar/stats.controller.js